import { render } from "./NotificationPage.vue?vue&type=template&id=3a114b23"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"

import "./NotificationPage.vue?vue&type=style&index=0&id=3a114b23&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__